import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { VisbilitySettingsFragmentDoc } from '../../../../../../../components/Form/components/VisibilitySettings/graphql/fragment/generated/VisibilitySettings';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { TaskViewConfigFragmentDoc } from '../../fragments/generated/taskViewConfig';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FileQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
  rootActionItemStatus?: Types.InputMaybe<Types.RootActionItemFilter>;
}>;


export type FileQuery = { file?: { id: string, category: Types.FileCategoryEnum, includes?: Array<Types.FileContentTypeEnum> | null, taskCount?: number | null, name: string, description?: string | null, createdAt: string, projectStatus?: Types.FileProjectStatusEnum | null, projectOwnerId?: string | null, dueDate?: string | null, systemGenerated?: boolean | null, meta?: string | null, filterQuery?: string | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, createdBy?: { createdById: string, name?: string | null } | null, clients: Array<{ id: string, clientName: string }>, visibilitySettings: { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null }, media?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, stages?: Array<{ stageId: string, name: string, description?: string | null, progress: number, iconSettings?: { type: Types.IconTypeEnum, value: string } | null } | null> | null, taskViewConfigs?: Array<{ name: string, visible: boolean, label: string, order: number, width: number, editable: boolean, entityId?: string | null, entityType?: Types.UserViewFieldEntityTypeEnum | null, provider?: Types.IntegrationProviderEnum | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, tagEntitySettings?: { disableGrouping?: boolean | null } | null }> | null, widgetMetrics: { metrics: Array<{ metricType: Types.FileWidgetMetricTypeEnum, icon: string, metric: string }> } } | null };


export const FileDocument = /*#__PURE__*/ gql`
    query file($filters: GetByIdFilter!, $rootActionItemStatus: RootActionItemFilter = ROOT_ACTION_ITEMS) {
  file(filters: $filters) {
    id
    category
    includes
    taskCount
    iconSettings {
      type
      value
    }
    name
    description
    createdAt
    projectStatus
    createdBy {
      createdById
      name
    }
    clients {
      id
      clientName
    }
    visibilitySettings {
      ...VisbilitySettings
    }
    media {
      ...EntityMedia
    }
    projectOwnerId
    dueDate
    stages {
      stageId
      name
      description
      iconSettings {
        type
        value
      }
      progress
    }
    systemGenerated
    meta
    filterQuery
    taskViewConfigs {
      ...TaskViewConfig
    }
    widgetMetrics(filters: {rootActionItemStatus: $rootActionItemStatus}) {
      metrics {
        metricType
        icon
        metric
      }
    }
  }
}
    ${VisbilitySettingsFragmentDoc}
${EntityMediaFragmentDoc}
${TaskViewConfigFragmentDoc}`;

export function useFileQuery(options: Omit<Urql.UseQueryArgs<FileQueryVariables>, 'query'>) {
  return Urql.useQuery<FileQuery, FileQueryVariables>({ query: FileDocument, ...options });
};